import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { customerApi } from '../api/customerApi';
import { ToastMessage } from '../components/ToastMessage';

interface GenerateLinkParams {
  customerId: string;
}

export const useGenerateLinkToResetPassword = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(
    (_: any, variables: { customerId: string }) => {
      queryClient.invalidateQueries({
        queryKey: ['reset-password', variables.customerId],
      });
      ToastMessage({
        content: 'Link gerado com sucesso!',
        type: 'success',
      });
    },
    [queryClient]
  );

  const onError = useCallback(() => {
    ToastMessage({
      content: 'Falha ao gerar link. Tente novamente!',
      type: 'error',
    });
  }, [queryClient]);

  const { mutateAsync: generateLink, isPending: isLoading } = useMutation({
    mutationFn: ({ customerId }: GenerateLinkParams) =>
      customerApi.generateLinkToResetPassword(customerId),
    onSuccess,
    onError,
  });

  return { generateLink, isLoading };
};
